import {useEffect, useLayoutEffect} from 'react';

import {isServer} from 'coreUtils/utils';

const useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect;

export default useIsomorphicLayoutEffect;
